import { useTranslation } from "react-i18next";
import { Shield, Users, Award, Clock, Phone } from "lucide-react";
import contactImage from "@assets/stock_images/professional_car_was_0914d06f.jpg";

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen pt-24 pb-24">
      {/* Intro */}
      <div className="container mx-auto px-4 mb-24">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 font-display">{t("about.title")}</h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            {t("about.subtitle")}
          </p>
        </div>
      </div>

      {/* Values Grid */}
      <div className="bg-muted py-24 border-y border-border">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-12">
            {[
              {
                icon: <Shield className="w-8 h-8 text-primary" />,
                title: t("about.qualityFirst"),
                desc: t("about.qualityFirstDesc")
              },
              {
                icon: <Users className="w-8 h-8 text-primary" />,
                title: t("about.ecoFriendly"),
                desc: t("about.ecoFriendlyDesc")
              },
              {
                icon: <Award className="w-8 h-8 text-primary" />,
                title: t("about.satisfaction"),
                desc: t("about.satisfactionDesc")
              }
            ].map((item, i) => (
              <div key={i} className="text-center">
                <div className="w-16 h-16 bg-card rounded-2xl shadow-sm border border-border flex items-center justify-center mx-auto mb-6">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-muted-foreground">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Location & Contact Info */}
      <div className="container mx-auto px-4 py-24">
        <div className="bg-card rounded-3xl overflow-hidden border border-border shadow-xl grid md:grid-cols-2">
          <div className="bg-slate-200 dark:bg-slate-800 min-h-[300px] relative">
             <img 
              src={contactImage} 
              alt="Car Wash Service" 
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/10" />
          </div>
          
          <div className="p-8 md:p-12 flex flex-col justify-center">
            <h2 className="text-3xl font-bold mb-8 font-display">{t("footer.contact")}</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Clock className="w-6 h-6 text-primary mt-1" />
                <div>
                  <h3 className="font-semibold text-lg">{t("contact.hours")}</h3>
                  <p className="text-muted-foreground">{t("contact.workingHours")}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-primary mt-1" />
                <div>
                  <h3 className="font-semibold text-lg">{t("contact.phone")}</h3>
                  <p className="text-muted-foreground">60022490</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
